export {InStockLabel} from './InStockLabel';
